import { MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown, MenuProps } from "antd";
import { useMemo } from "react";

type Props = {
  itemId: number;
  onModify: (id: number) => void;
  onDelete: (id: number) => void;
};

const DropdownOptionsConstatGravities: React.FC<Props> = ({
  itemId,
  onModify,
  onDelete,
}) => {
  const items = useMemo(() => {
    const _items: MenuProps["items"] = [
      {
        key: "modify",
        label: "Voir/Modifier la gravitÃ©",
        onClick: () => onModify(itemId),
      },
      {
        key: "delete",
        danger: true,
        label: (
          <a onClick={(e) => { e.stopPropagation(); onDelete(itemId); }}>
            Supprimer
          </a>
        ),
      },
    ];
    return _items;
  }, [itemId, onModify, onDelete]);

  return (
    <Dropdown menu={{ items }} trigger={["click"]}>
      <Button
        type="link"
        icon={<MoreOutlined />}
        onClick={(e) => e.stopPropagation()}
      />
    </Dropdown>
  );
};

export default DropdownOptionsConstatGravities;
